import React from 'react';
import { Copy, Check } from 'lucide-react';
import { useAppStore } from '../store';

export const TextOutput: React.FC = () => {
  const [copied, setCopied] = React.useState(false);
  const extractedText = useAppStore((state) => state.extractedText);

  const handleCopy = async () => {
    if (extractedText) {
      await navigator.clipboard.writeText(extractedText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="h-[400px] bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-6 overflow-auto border border-gray-200 shadow-inner relative">
      {extractedText && (
        <button
          onClick={handleCopy}
          className="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur-sm hover:bg-white/90 rounded-lg transition-all duration-300 shadow-sm hover:shadow-md"
          title={copied ? "Copied!" : "Copy text"}
        >
          {copied ? (
            <Check className="w-5 h-5 text-green-600" />
          ) : (
            <Copy className="w-5 h-5 text-gray-600" />
          )}
        </button>
      )}
      
      {extractedText ? (
        <p className="whitespace-pre-wrap font-mono text-gray-800">
          {extractedText}
        </p>
      ) : (
        <div className="h-full flex items-center justify-center">
          <p className="text-gray-500 text-sm">
            Extracted text will appear here...
          </p>
        </div>
      )}
    </div>
  );
};